export function getQuoteEnabled({ source, transactionType, tenure, onLoaded, onError }) {
  fetch("/api/quote/enabled", {
    method: "POST",
    body: JSON.stringify({
      source: source,
      transaction_type: transactionType,
      tenure: tenure,
    }),
  })
    .then((resp) => {
      if (!resp.ok) {
        throw new Error("non-success response");
      }
      return resp.json();
    })
    .then((data) => {
      onLoaded(data.enabled, data.reasons);
    })
    .catch((err) => {
      onError(err);
    });
}
